import { Layout, Layout as AntLayout } from 'antd';
import styled from 'styled-components';

export const MainWrapper = styled(Layout)`
  position: relative;
  min-height: 100dvh;
  height: fit-content;
  background-color: transparent;

  &:before {
    content: '';
    display: block;
    background-color: #ebecec;
    width: 60%;
    height: 79%;
    position: absolute;
    bottom: 0;
    left: clamp(0px, 6%, 82px);
    border-top-right-radius: calc(max(5vw, 124px));
  }
`;

interface ManiContentLayoutProps {
  isMobileMenuOpen: boolean;
}

export const ManiContentLayout = styled.div<ManiContentLayoutProps>`
  min-height: 100dvh;
  height: 100%;

  ${(props) => props.isMobileMenuOpen && 'overflow: hidden; height: 100dvh;'}

  &:before {
    content: '';
    display: block;
    background-color: #ebecec;
    width: 31%;
    height: 40.1%;
    position: absolute;
    top: 0;
    right: 0;
    border-bottom-left-radius: calc(max(5vw, 108px));
  }
`;

export const RightSideLayout = styled(AntLayout)`
  z-index: 1;
  background: transparent;
  position: relative;
`;

export const LayoutHeader = styled(Layout.Header)`
  padding: 16px 0 0 0;
  background: transparent;
`;

export const LayoutContent = styled(Layout.Content)`
  padding: 16px 18px;
  min-height: 280px;
  background: transparent;
`;
